import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { required } from "../Common/validation";
import InputGroup from "react-bootstrap/InputGroup";
import { useDispatch, useSelector } from "react-redux";
import { Link, Navigate, useNavigate } from "react-router-dom";
import ".././css/common.css";
import { APPLICATION_ID, AUTH_BASE_URL, BASE_URL } from "../Config/Config";
import Navbarp from "../Components/CommonComponents/Navbarp";
import { setTempToken, setSessionId } from "../features/Loginuser";
import { Spinner } from "react-bootstrap";
import SmallLoader from "../Components/CommonComponents/SmallLoader";
import { loginWithAxios } from "../utils/AxiosAuthClient";

function Home() {
  const navigate = useNavigate();
  return (
    <div className="container">
      <Navbarp />
      <div style={{ marginTop: "150px" }}>
        <h1 className="text-center fs-1 m-5 p-3  fw-bold">
          Welcome to Liter Admin Panel
        </h1>
        <div className="d-flex w-100 flex-row justify-content-center">
          <div
            className="d-flex w-100 flex-column justify-content-center"
            style={{ maxWidth: "500px" }}
          >
            <div>
              <p className="m-3 fs-3 fw-bold m-1 text-center">
                Please Login to website
              </p>
              <div className="d-grid gap-2">
                <Button
                  variant="warning"
                  style={{ Color: "white" }}
                  size="lg"
                  type="button"
                  onClick={() => navigate("/login")}
                >
                  Login
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
